import { Box } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { isEmpty } from 'ramda';
import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { Link as RouterLink, Route } from 'react-router-dom';
import { RouteLocationState } from '../../common/WithQueryParams';

const messages = defineMessages({
  'breadcrumbs.bulkImport': {
    defaultMessage: 'Bulk Import',
    id: 'breadcrumbs.bulkImport'
  },
  'breadcrumbs.checkpointTypes': {
    defaultMessage: 'Checkpoint Types',
    id: 'breadcrumbs.checkpointTypes'
  },
  'breadcrumbs.checkpoints': {
    defaultMessage: 'Checkpoints',
    id: 'breadcrumbs.checkpoints'
  },
  'breadcrumbs.libraries': {
    defaultMessage: 'Libraries',
    id: 'breadcrumbs.libraries'
  },
  'breadcrumbs.new': {
    defaultMessage: 'New',
    id: 'breadcrumbs.new'
  },
  'breadcrumbs.update': {
    defaultMessage: 'Update',
    id: 'breadcrumbs.update'
  },
  'breadcrumbs.userDefinedRoles': {
    defaultMessage: 'User-Defined Roles',
    id: 'breadcrumbs.userDefinedRoles'
  }
});

const breadcrumbNameMap: Record<string, MessageDescriptor> = {
  '/checkpoints': messages['breadcrumbs.checkpoints'],
  '/checkpointtypes': messages['breadcrumbs.checkpointTypes'],
  '/libraries': messages['breadcrumbs.libraries'],
  '/user-defined-roles': messages['breadcrumbs.userDefinedRoles']
};

const breadcrumbRegexMap: Record<string, MessageDescriptor> = {
  '/[^/]+/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}': messages['breadcrumbs.update'],
  '/[^/]+/bulkImport': messages['breadcrumbs.bulkImport'],
  '/[^/]+/new': messages['breadcrumbs.new']
};

const getBreadcrumbNameByRegex = (to: string) => {
  const matchingRegex = Object.keys(breadcrumbRegexMap).find(regexString => new RegExp(regexString, 'g').test(to));

  if (matchingRegex) {
    return breadcrumbRegexMap[matchingRegex];
  }

  return '';
};

export default function SimpleBreadcrumbs() {
  const { formatMessage } = useIntl();

  return (
    <Route>
      {({ location, history }) => {
        const pathnames = location.pathname.split('/').filter(x => x);
        const locationState = history.location.state as RouteLocationState;
        let params: string = '';

        if (locationState && !isEmpty(locationState)) {
          params = locationState.previousLocation.search;
        }

        return (
          <Box paddingTop={3} paddingBottom={3}>
            <Breadcrumbs aria-label="breadcrumb">
              <RouterLink color="inherit" to="/">
                Home
              </RouterLink>
              {pathnames.map((_, index) => {
                const last = index === pathnames.length - 1;
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                const breadcrumbMessageId = breadcrumbNameMap[to] || getBreadcrumbNameByRegex(to);
                const breadcrumb = breadcrumbMessageId ? formatMessage(breadcrumbMessageId) : '';

                const linkUrl = to + params;

                return last ? (
                  <Typography color="textPrimary" key={to}>
                    {breadcrumb}
                  </Typography>
                ) : (
                  <RouterLink color="inherit" to={linkUrl} key={to}>
                    {breadcrumb}
                  </RouterLink>
                );
              })}
            </Breadcrumbs>
          </Box>
        );
      }}
    </Route>
  );
}
